// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  margin-top: 10px !important;
  border: none !important;
  border-radius: 8px !important;
}

.card-header {
  padding: 6px 15px !important;
  border-radius: 8px 8px 0px 0px !important;
  background-color: var(--app-surface);
  border-bottom: solid 1px var(--app-legacy-mini-divider);
  container-type: inline-size;
  container-name: mini-card-header;
}

.card-header .header-buttons i {
  /* color: var(--app-legacy-menu-card-text); */
  /* font-size: var(--app-font-size-22px); */
  cursor: pointer;
  transition: color 0.2s ease;
}

.rounded-all {
  border-radius: 8px !important;
  border-bottom: none !important;
}

.mini-card-header-layout {
  display: grid;
  grid-template-areas: 'icon title status actions';
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  column-gap: 8px;
}

.mini-card-header-layout.has-header-content {
  grid-template-areas: 'icon title content status actions';
  grid-template-columns: auto minmax(0, 1fr) minmax(0, 60%) auto auto;
}

.mini-card-header-layout:not(.has-title-icon) {
  grid-template-areas: 'title status actions';
  grid-template-columns: minmax(0, 1fr) auto auto;
}

.mini-card-header-layout.has-header-content:not(.has-title-icon) {
  grid-template-areas: 'title content status actions';
  grid-template-columns: minmax(0, 1fr) minmax(0, 60%) auto auto;
}

.mini-card-title-icon {
  grid-area: icon;
  font-size: var(--app-font-size-18px);
}

.mini-card-title {
  grid-area: title;
  min-width: 0;
  margin: 0;
}

.mini-card-header-content {
  grid-area: content;
  min-width: 0;
  justify-self: stretch;
}

.mini-card-header-status {
  grid-area: status;
  display: flex;
  min-width: 0;
  align-items: center;
}

.mini-card-status {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-right: 0;
  white-space: nowrap;
}

.header-buttons {
  grid-area: actions;
  display: flex;
  min-width: 99px;
  align-self: stretch;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
}

.mini-card-status-tooltip {
  cursor: pointer;
}

.mini-card-status-action {
  padding: 0;
  border: 0;
  background: transparent;
  line-height: inherit;
  cursor: pointer;
  text-decoration: none;
}

.mini-card-status-action:hover {
  text-decoration: underline;
}

.mini-card-status-chevron {
  font-size: var(--app-font-size-0-85em);
  margin-left: 2px;
}

.card-body {
  padding: 6px 15px !important;
}

.card-body ::ng-deep .form-group {
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin: 0 0 10px !important;
}

.card-body ::ng-deep .row:has(> .form-group) {
  margin-right: -15px !important;
  margin-left: -15px !important;
}

.card-body ::ng-deep .row > .form-group {
  padding-right: 15px !important;
  padding-left: 15px !important;
}

.card-body ::ng-deep small {
  margin-bottom: -2px !important;
}

.icon-card-header {
  font-size: var(--app-font-size-22px);
  line-height: 1;
  text-decoration: none;
}

@container mini-card-header (max-width: 760px) {
  .mini-card-header-layout:not(.has-title-icon) {
    grid-template-areas:
      'status'
      'title';
    grid-template-columns: minmax(0, 1fr);
    column-gap: 0;
  }

  .mini-card-header-layout {
    position: relative;
    grid-template-areas:
      'status status'
      'icon title';
    grid-template-columns: auto minmax(0, 1fr);
    row-gap: 4px;
  }

  .mini-card-header-layout.has-header-content {
    grid-template-areas:
      'status status'
      'icon title'
      '. content';
    grid-template-columns: auto minmax(0, 1fr);
  }

  .mini-card-header-layout.has-header-content:not(.has-title-icon) {
    grid-template-areas:
      'status'
      'title'
      'content';
    grid-template-columns: minmax(0, 1fr);
  }

  .mini-card-header-content {
    max-width: none !important;
  }

  .mini-card-header-status {
    justify-content: center;
  }

  .mini-card-header-layout:has(.header-buttons) .mini-card-title,
  .mini-card-header-layout:has(.header-buttons) .mini-card-header-content {
    padding-right: 107px;
  }

  .header-buttons {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
}

.no-after::after {
  display: none;
}

@media (max-width: 767px) {
  .mini-card-header-layout,
  .mini-card-header-layout:not(.has-title-icon),
  .mini-card-header-layout.has-header-content,
  .mini-card-header-layout.has-header-content:not(.has-title-icon) {
    grid-template-areas:
      'status status actions'
      'icon title title';
    grid-template-columns: auto minmax(0, 1fr) auto;
  column-gap: 8px;
    row-gap: 4px;
  }

  .mini-card-header-layout:not(.has-title-icon) {
    grid-template-areas:
      'status status actions'
      'title title title';
  }

  .mini-card-header-layout.has-header-content {
    grid-template-areas:
      'status status actions'
      'icon title title'
      'content content content';
  }

  .mini-card-header-layout.has-header-content:not(.has-title-icon) {
    grid-template-areas:
      'status status actions'
      'title title title'
      'content content content';
  }

  .mini-card-header-status {
    justify-content: flex-start;
  }

  .mini-card-status {
    white-space: normal;
  }

  .mini-card-header-layout .mini-card-title,
  .mini-card-header-layout .mini-card-header-content,
  .mini-card-header-layout:has(.header-buttons) .mini-card-title,
  .mini-card-header-layout:has(.header-buttons) .mini-card-header-content {
    padding-right: 0;
  }

  .header-buttons {
    position: static;
    transform: none;
  min-width: 0;
  }
}

@media (max-width: 640px) {
  :host {
    display: block;
    margin-left: 8px;
    margin-right: 8px;
  }
}

/* .card {
  margin-top: 36px;
  border-radius: 7px !important;
}

.card-header {
    position: relative;
  top: -20px;
  border-radius: 6px !important;
}

.card-body {
  margin-top: -20px;
  padding: 0px 6px 6px !important;
}

.icon-card-header {
  color: var(--app-surface);
  font-size: var(--app-font-size-25px);
  text-decoration: none;
    position: relative;
  top: 2px;
}

.no-after::after {
  display: none;
} */

.card-header { border-top: 1.75px solid var(--app-primary) !important; }
.header-buttons { color: var(--app-primary); }
.header-content-width-45 { max-width: 45%; }
.header-content-width-60 { max-width: 60%; }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/mini-card/mini-card.component.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,oCAAoC;EACpC,uDAAuD;EACvD,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;EAC7C,0CAA0C;EAC1C,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oDAAoD;EACpD,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wDAAwD;EACxD,mEAAmE;AACrE;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;EACE,mDAAmD;EACnD,8DAA8D;AAChE;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE;;aAES;IACT,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB;;kBAEc;IACd,0CAA0C;IAC1C,YAAY;EACd;;EAEA;IACE;;;iBAGa;IACb,0CAA0C;EAC5C;;EAEA;IACE;;;eAGW;IACX,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;;;IAIE;;wBAEoB;IACpB,+CAA+C;EACjD,eAAe;IACb,YAAY;EACd;;EAEA;IACE;;yBAEqB;EACvB;;EAEA;IACE;;;+BAG2B;EAC7B;;EAEA;IACE;;;+BAG2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;;IAIE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB,YAAY;EACZ;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG;;AAEH,eAAe,sDAAsD,EAAE;AACvE,kBAAkB,yBAAyB,EAAE;AAC7C,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE","sourcesContent":[".card {\n  margin-top: 10px !important;\n  border: none !important;\n  border-radius: 8px !important;\n}\n\n.card-header {\n  padding: 6px 15px !important;\n  border-radius: 8px 8px 0px 0px !important;\n  background-color: var(--app-surface);\n  border-bottom: solid 1px var(--app-legacy-mini-divider);\n  container-type: inline-size;\n  container-name: mini-card-header;\n}\n\n.card-header .header-buttons i {\n  /* color: var(--app-legacy-menu-card-text); */\n  /* font-size: var(--app-font-size-22px); */\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.rounded-all {\n  border-radius: 8px !important;\n  border-bottom: none !important;\n}\n\n.mini-card-header-layout {\n  display: grid;\n  grid-template-areas: 'icon title status actions';\n  grid-template-columns: auto minmax(0, 1fr) auto auto;\n  align-items: center;\n  column-gap: 8px;\n}\n\n.mini-card-header-layout.has-header-content {\n  grid-template-areas: 'icon title content status actions';\n  grid-template-columns: auto minmax(0, 1fr) minmax(0, 60%) auto auto;\n}\n\n.mini-card-header-layout:not(.has-title-icon) {\n  grid-template-areas: 'title status actions';\n  grid-template-columns: minmax(0, 1fr) auto auto;\n}\n\n.mini-card-header-layout.has-header-content:not(.has-title-icon) {\n  grid-template-areas: 'title content status actions';\n  grid-template-columns: minmax(0, 1fr) minmax(0, 60%) auto auto;\n}\n\n.mini-card-title-icon {\n  grid-area: icon;\n  font-size: var(--app-font-size-18px);\n}\n\n.mini-card-title {\n  grid-area: title;\n  min-width: 0;\n  margin: 0;\n}\n\n.mini-card-header-content {\n  grid-area: content;\n  min-width: 0;\n  justify-self: stretch;\n}\n\n.mini-card-header-status {\n  grid-area: status;\n  display: flex;\n  min-width: 0;\n  align-items: center;\n}\n\n.mini-card-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  margin-right: 0;\n  white-space: nowrap;\n}\n\n.header-buttons {\n  grid-area: actions;\n  display: flex;\n  min-width: 99px;\n  align-self: stretch;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.mini-card-status-tooltip {\n  cursor: pointer;\n}\n\n.mini-card-status-action {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  line-height: inherit;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.mini-card-status-action:hover {\n  text-decoration: underline;\n}\n\n.mini-card-status-chevron {\n  font-size: var(--app-font-size-0-85em);\n  margin-left: 2px;\n}\n\n.card-body {\n  padding: 6px 15px !important;\n}\n\n.card-body ::ng-deep .form-group {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin: 0 0 10px !important;\n}\n\n.card-body ::ng-deep .row:has(> .form-group) {\n  margin-right: -15px !important;\n  margin-left: -15px !important;\n}\n\n.card-body ::ng-deep .row > .form-group {\n  padding-right: 15px !important;\n  padding-left: 15px !important;\n}\n\n.card-body ::ng-deep small {\n  margin-bottom: -2px !important;\n}\n\n.icon-card-header {\n  font-size: var(--app-font-size-22px);\n  line-height: 1;\n  text-decoration: none;\n}\n\n@container mini-card-header (max-width: 760px) {\n  .mini-card-header-layout:not(.has-title-icon) {\n    grid-template-areas:\n      'status'\n      'title';\n    grid-template-columns: minmax(0, 1fr);\n    column-gap: 0;\n  }\n\n  .mini-card-header-layout {\n    position: relative;\n    grid-template-areas:\n      'status status'\n      'icon title';\n    grid-template-columns: auto minmax(0, 1fr);\n    row-gap: 4px;\n  }\n\n  .mini-card-header-layout.has-header-content {\n    grid-template-areas:\n      'status status'\n      'icon title'\n      '. content';\n    grid-template-columns: auto minmax(0, 1fr);\n  }\n\n  .mini-card-header-layout.has-header-content:not(.has-title-icon) {\n    grid-template-areas:\n      'status'\n      'title'\n      'content';\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .mini-card-header-content {\n    max-width: none !important;\n  }\n\n  .mini-card-header-status {\n    justify-content: center;\n  }\n\n  .mini-card-header-layout:has(.header-buttons) .mini-card-title,\n  .mini-card-header-layout:has(.header-buttons) .mini-card-header-content {\n    padding-right: 107px;\n  }\n\n  .header-buttons {\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n  }\n}\n\n.no-after::after {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .mini-card-header-layout,\n  .mini-card-header-layout:not(.has-title-icon),\n  .mini-card-header-layout.has-header-content,\n  .mini-card-header-layout.has-header-content:not(.has-title-icon) {\n    grid-template-areas:\n      'status status actions'\n      'icon title title';\n    grid-template-columns: auto minmax(0, 1fr) auto;\n  column-gap: 8px;\n    row-gap: 4px;\n  }\n\n  .mini-card-header-layout:not(.has-title-icon) {\n    grid-template-areas:\n      'status status actions'\n      'title title title';\n  }\n\n  .mini-card-header-layout.has-header-content {\n    grid-template-areas:\n      'status status actions'\n      'icon title title'\n      'content content content';\n  }\n\n  .mini-card-header-layout.has-header-content:not(.has-title-icon) {\n    grid-template-areas:\n      'status status actions'\n      'title title title'\n      'content content content';\n  }\n\n  .mini-card-header-status {\n    justify-content: flex-start;\n  }\n\n  .mini-card-status {\n    white-space: normal;\n  }\n\n  .mini-card-header-layout .mini-card-title,\n  .mini-card-header-layout .mini-card-header-content,\n  .mini-card-header-layout:has(.header-buttons) .mini-card-title,\n  .mini-card-header-layout:has(.header-buttons) .mini-card-header-content {\n    padding-right: 0;\n  }\n\n  .header-buttons {\n    position: static;\n    transform: none;\n  min-width: 0;\n  }\n}\n\n@media (max-width: 640px) {\n  :host {\n    display: block;\n    margin-left: 8px;\n    margin-right: 8px;\n  }\n}\n\n/* .card {\n  margin-top: 36px;\n  border-radius: 7px !important;\n}\n\n.card-header {\n    position: relative;\n  top: -20px;\n  border-radius: 6px !important;\n}\n\n.card-body {\n  margin-top: -20px;\n  padding: 0px 6px 6px !important;\n}\n\n.icon-card-header {\n  color: var(--app-surface);\n  font-size: var(--app-font-size-25px);\n  text-decoration: none;\n    position: relative;\n  top: 2px;\n}\n\n.no-after::after {\n  display: none;\n} */\n\n.card-header { border-top: 1.75px solid var(--app-primary) !important; }\n.header-buttons { color: var(--app-primary); }\n.header-content-width-45 { max-width: 45%; }\n.header-content-width-60 { max-width: 60%; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
